export const helpHomePath = "/help";

export const toHelpSlug = (value = "") =>
  String(value)
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const isMongoId = (value = "") => /^[a-f0-9]{24}$/i.test(String(value));

export const helpCategoryPath = (category) =>
  `${helpHomePath}/${toHelpSlug(
    typeof category === "string" ? category : category?.heading
  )}`;

export const helpSubheadingPath = (category, subheading) =>
  `${helpCategoryPath(category)}/${toHelpSlug(
    typeof subheading === "string" ? subheading : subheading?.subHeading
  )}`;

export const helpArticlePath = (category, subheading, title, tertiaryId) => {
  const slugPath = `${helpSubheadingPath(category, subheading)}/${toHelpSlug(title)}`;
  return tertiaryId ? `${slugPath}/${tertiaryId}` : slugPath;
};

export const flattenHelpArticles = (helpData = []) =>
  helpData.flatMap((heading) =>
    (heading.subHeadings || []).flatMap((sub) =>
      (sub.tertiarySubHeadings || []).map((tertiary) => ({
        id: tertiary._id,
        headingId: heading._id,
        subId: sub._id,
        title: tertiary.tertiarySubHeading,
        category: heading.heading,
        subHeading: sub.subHeading,
        heading,
        sub,
        tertiary,
        path: helpArticlePath(
          heading.heading,
          sub.subHeading,
          tertiary.tertiarySubHeading,
          tertiary._id
        ),
        categoryPath: helpCategoryPath(heading.heading),
        subheadingPath: helpSubheadingPath(heading.heading, sub.subHeading),
        categorySlug: toHelpSlug(heading.heading),
        subheadingSlug: toHelpSlug(sub.subHeading),
        articleSlug: toHelpSlug(tertiary.tertiarySubHeading),
      }))
    )
  );

export const findArticleById = (helpData, id) =>
  flattenHelpArticles(helpData).find((item) => String(item.id) === String(id));

export const findArticleByPath = (
  helpData,
  categorySlug,
  articleSlug,
  subheadingSlug
) => {
  const matches = flattenHelpArticles(helpData).filter((item) => {
    if (item.categorySlug !== categorySlug || item.articleSlug !== articleSlug) {
      return false;
    }
    if (subheadingSlug) return item.subheadingSlug === subheadingSlug;
    return true;
  });
  return matches.length === 1 ? matches[0] : undefined;
};

export const findCategoryBySlug = (helpData, categorySlug) =>
  (helpData || []).find(
    (heading) => toHelpSlug(heading.heading) === categorySlug
  );

export const findSubheadingBySlug = (heading, subheadingSlug) =>
  (heading?.subHeadings || []).find(
    (sub) => toHelpSlug(sub.subHeading) === subheadingSlug
  );
